import { CURRENCY } from 'src/types';

export enum FINANCIAL_DOCUMENT_TYPE {
    INVOICE = 'invoice',
    PROFORMA = 'proforma',
    RECEIPT = 'receipt',
    CREDIT_NOTE = 'credit_note',
    DEBIT_NOTE = 'debit_note',
}

export enum FINANCIAL_DOCUMENT_STATUS {
    DRAFT = 'draft',
    ISSUED = 'issued',
    VOIDED = 'voided',
}

export enum FINANCIAL_DOCUMENT_PAYMENT_STATUS {
    PAID = 'paid',
    NONE = 'none',
    PARTIAL = 'partial',
}

export type FinancialDocument = {
    id: string;
    number: string;
    created_at: string;
    tenant: {
        id: string;
        name: string;
    };
    customer: {
        id: string;
        name: string;
    };
    financial_document: {
        id: string;
        number: string;
    };
    type: FINANCIAL_DOCUMENT_TYPE;
    status: FINANCIAL_DOCUMENT_STATUS;
    amount: number;
    amount_with_tax: number;
    paid_amount?: number;
    remaining_amount?: number;
    currency: CURRENCY;
    accounting_range: {
        id: string;
        name: string;
    };
    supplier: {
        id: string;
        name: string;
    };
    public_description: string | null;
    internal_description: string | null;
    tax_event_date: string | null;
    payment_due_date: string | null;
    issue_due_date: string | null;
    payment_status: FINANCIAL_DOCUMENT_PAYMENT_STATUS;
    /** A short-lived signed absolute URL, or null before the PDF exists. Open PDFs via the `pdf/` endpoint. */
    document_file: string | null;
    tax_amount: number;
    issued_by: {
        id: string;
        name: string;
    };
};

/** Response of `GET .../financial-document/:id/pdf/` - a short-lived signed URL to the (possibly just generated) PDF. */
export type FinancialDocumentPdf = {
    url: string;
};
